











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputEmail extends Vue {
  @Prop()
  placeholder!: string;
  public label = 'Email';
  public error = '';
  public icon = 'email'

  onChange($text) {
    console.error($text)
      if($text.length === 0){
          this.error = 'Correo invalido';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
